import React, { PureComponent, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Panel from '../../../../UniformComponents/Panel'
import Button from '../../../../UniformComponents/Button'
import Badge from '../../../../UniformComponents/Badge'
import Accordion from './Accordion'
import Tooltip from '../../../../UniformComponents/Tooltip'
import Select from '../../../form/Select'
import Switch from '../../../../UniformComponents/Switch'
import LinkButton from '../../../../UniformComponents/LinkButton'
import CheckboxGroup from '../../../form/CheckboxGroup'
import RuleGroup from '../Modal/Filter/model/RuleGroup'
import InfoAccordion from '../../../InfoAccordion'
import HoverInfo from '../../../../UniformComponents/HoverInfo'
import ReportOverview from './ReportOverview'
import ReportFilters from './ReportFilters'

const StatusBadge = ({ type, label, icon }) => (
    <div style={{ width: '100%', padding: '0 20px' }}>
        <Badge type={type} cssClass="rounded" label={i18n.t(label)} icon={icon} style={{ maxWidth: '100%' }} />
    </div>
)

const ReportStats = ({ isMaxbi, stats, reportData }) => {
    const {
        completed, dropped, screened, total,
    } = stats

    if (isMaxbi) {
        const inProgress = R.pathOr([], ['stats', 'details', 'complete'], reportData).some((e) => e !== 0) && !total

        if (inProgress) return <StatusBadge type="warning" label="inProgress" icon="fal fa-circle-xmark" />

        if (!total) return <StatusBadge type="error" label="notStarted" icon="fal fa-ban" />

        return <StatusBadge type="success" label="completed" icon="fal fa-circle-check" />
    }

    const statsData = [
        {
            label: 'report_dropoff_completions', value: completed, type: 'success', icon: 'fa-regular fa-check',
        },
        {
            label: 'report_dropoff_dropoffs', value: dropped, type: 'warning', icon: 'fa-regular fa-arrow-down',
        },
        {
            label: 'report_dropoff_screening_exits', value: screened, type: 'error', icon: 'fa-regular fa-ban',
        },
        {
            label: 'report_total_responses', value: total, type: null, style: { background: '#FFF' },
        },
    ]

    return (
        <div className="filterStats">
            {statsData.map(({
                label, value, type, icon, style,
            }) => (
                <div className="stat" key={label}>
                    {i18n.t(label)}
                    <Badge type={type} cssClass="rounded" label={value} icon={icon} style={style} />
                </div>
            ))}
        </div>
    )
}

@observer
class LeftPanel extends PureComponent {
    constructor(props) {
        super(props)
        const { store } = props
        this.isMaxbi = store.survey.isMaxbi()
        this.state = {
            locale: store.survey.metadata.defaultLocale,
            showDebug: false,
            showAdminBox: false,
            showDownload: false,
            downloadTitle: '',
            downloadLoading: false,
            downloadUrl: '',
        }
    }

    componentWillUnmount() {
        const { reportStore } = this.props
        const { appStore } = reportStore

        appStore.showDebug = false
    }

    toggleAdminBox = () => {
        const stateCopy = { ...this.state }
        stateCopy.showAdminBox = !stateCopy.showAdminBox
        console.log(`showAdminBox ${stateCopy.showAdminBox}`)
        this.setState(stateCopy)
    }

    handleCurrency = (event) => {
        const { reportStore } = this.props
        reportStore.currentCurrency = event.target.value
    }

    editAdvancedXTab = (xtabId) => {
        const { reportStore } = this.props
        const xtab = R.pathOr([], ['xTabs'], reportStore).find(({ id }) => id === xtabId)
        reportStore.currAdvancedXTab = xtab
        reportStore.showAdvancedXTab = true
    }

    debugControl = () => {
        const { showAdminBox } = this.state
        const { toggleAdminBox } = this
        const { reportStore } = this.props
        const { appStore } = reportStore
        const { showDebug, toggleDebug } = appStore

        if (!appStore.isExploriAdmin()) return null

        const text = i18n.t(`${showDebug ? 'adminBox.hide' : 'adminBox.show'}`)
        const className = showDebug ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'

        return (
            <div
                style={{
                    flex: 1, cursor: 'pointer', display: 'flex', justifyContent: 'end',
                }}
                onClick={toggleAdminBox}
            >
                {showAdminBox && (
                    <Tooltip
                        text={text}
                        direction="left"
                        isNew
                    >
                        <i
                            className={className}
                            onClick={toggleDebug}
                            style={{ fontSize: '16px' }}
                        />
                    </Tooltip>
                )}
            </div>
        )
    }

    changeSurveyStatuses = (obj) => {
        const { reportStore } = this.props
        const { selectedResponseStatuses, responseStatuses, reloadData } = reportStore
        selectedResponseStatuses.clear()
        obj.value.forEach((v) => {
            selectedResponseStatuses.set(
                v,
                responseStatuses.find(({ value }) => value === v),
            )
        })
        reloadData()
    }

    render() {
        const {
            reportStore, store,
        } = this.props
        const { appStore, exchangeRates } = reportStore
        const { survey } = store
        const data = reportStore.reportData.stats

        const completed = R.pathOr(0, ['aggregate', 'total', 'complete'], data)
        const screened = R.pathOr(0, ['aggregate', 'total', 'screen'], data)
        const dropped = R.pathOr(0, ['aggregate', 'total', 'drop'], data)
        const total = completed + screened + dropped

        const filterRulesExist = Object.entries(reportStore.filters).some(([_, ruleGroup]) => (ruleGroup.hasRules()))

        if (process.env.USE_NEW_HEADER_UI) {
            return (
                <div className="report-left-panel" id="pane1">
                    <ReportOverview store={store} reportStore={reportStore} />
                    <br />
                    <br />
                    <ReportFilters store={store} reportStore={reportStore} />
                </div>
            )
        }

        return (
            <Fragment>
                <Panel id="pane1" cssClass="filter options">
                    <div style={{ padding: '16px 16px 0px 16px' }}>
                        <div style={{ display: 'flex' }}>
                            <h3>{i18n.t(this.isMaxbi ? 's_tab_maxbi_responses' : 's_tab_reporting')}</h3>

                            {this.debugControl()}
                        </div>

                        <br />

                        <hr />

                        <br />
                    </div>

                    <ReportStats
                        isMaxbi={this.isMaxbi}
                        stats={{
                            completed, screened, dropped, total,
                        }}
                        reportData={reportStore.reportData}
                    />

                    {this.isMaxbi
                        ? (
                            <div style={{ padding: '23px 16px 16px 16px' }}>
                                <Select
                                    label={i18n.t('report_currentCurrency')}
                                    options={Object.keys(exchangeRates).map((k) => ({ label: k, value: k }))}
                                    onBlur={({ value }) => reportStore.changeCurrentCurrency(value)}
                                    defaultValue={reportStore.currentCurrency}
                                />
                                <div
                                    className="areaUnitSwitch"
                                >
                                    <span>{i18n.t('refcodes_Square_Feet')}</span>
                                    <Switch
                                        state={reportStore.areaUnit === 'M2'}
                                        onToggle={reportStore.changeAreaUnit}
                                    />
                                    <span>{i18n.t('refcodes_Square_Metres')}</span>
                                </div>
                            </div>
                        )
                        : null }

                    {!this.isMaxbi && (
                        <Fragment>
                            <Accordion
                                label={i18n.t('report_filters')}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px',
                                        marginBottom: '25px',
                                    }}
                                >
                                    {reportStore.showQuickFilter
                                        ? (
                                            <InfoAccordion
                                                title={i18n.t('report.filter.quick.guide.title')}
                                                show={reportStore.showQuickFilterInfo}
                                                toggle={() => { reportStore.showQuickFilterInfo = !reportStore.showQuickFilterInfo }}
                                            >
                                                {i18n.t('report.filter.quick.guide.text')}
                                            </InfoAccordion>
                                        )
                                        : (
                                            <>
                                                <div className="statuses" style={{ position: 'relative' }}>
                                                    <CheckboxGroup
                                                        name="surveyStatus"
                                                        label={i18n.t('report_status_filter_label')}
                                                        options={reportStore.responseStatuses}
                                                        defaultChecked={Array.from(reportStore.selectedResponseStatuses).map(([key]) => key)}
                                                        onBlur={this.changeSurveyStatuses}
                                                        returnValueUnchanged
                                                    />
                                                </div>
                                                {Object.entries(reportStore.filters).map(([type, ruleGroup]) => (
                                                    !ruleGroup.hasRules()
                                                        ? null
                                                        : (
                                                            <div
                                                                style={{
                                                                    fontWeight: 600,
                                                                    padding: '8px',
                                                                    borderRadius: '5px',
                                                                    background: '#F7F8FA',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                }}
                                                                key={type}
                                                            >
                                                                {i18n.t(`report.filter.${type}`)}
                                                                <i
                                                                    className="fa-regular fa-circle-xmark"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        ruleGroup.discard()
                                                                        reportStore.saveFilter(type, RuleGroup.clone(ruleGroup))
                                                                    }}
                                                                />
                                                            </div>
                                                        )
                                                ))}
                                            </>
                                        )}
                                </div>
                                {!reportStore.showQuickFilter && process.env.USE_QUICK_FILTER && (
                                    <Button
                                        cssClass="primary regular"
                                        label={i18n.t('report.filter.quick.enable')}
                                        icon="fa-light fa-filter"
                                        onClick={reportStore.enableQuickFilters}
                                        style={{ justifyContent: 'center', width: '100%' }}
                                    />
                                )}
                                {reportStore.showQuickFilter && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            gap: 5,
                                            padding: '5px',
                                            position: 'relative',
                                            background: '#FFF',
                                            zIndex: 101,
                                        }}
                                    >
                                        <Button
                                            cssClass="primary regular"
                                            label={i18n.t('cancel')}
                                            onClick={reportStore.cancelQuickFilters}
                                            style={{ justifyContent: 'center', width: '100%', zIndex: 101 }}
                                        />
                                        <Button
                                            cssClass="secondary regular"
                                            label={i18n.t('report.filter.quick.apply')}
                                            onClick={reportStore.applyQuickFilter}
                                            style={{ justifyContent: 'center', width: '100%', zIndex: 101 }}
                                        />
                                    </div>
                                )}
                                <br />
                                {!reportStore.showQuickFilter && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', position: 'relative' }}>
                                        {filterRulesExist ? (
                                            <Button
                                                label={i18n.t('clearFilters')}
                                                onClick={() => reportStore.discardAllFilters()}
                                                cssClass="tertiary regular"
                                                icon="fa-regular fa-trash"
                                                style={{ justifyContent: 'center', width: '100%' }}
                                            />
                                        ) : null }
                                        {survey.metadata.isRapidSurvey
                                            ? (
                                                <HoverInfo
                                                    cssClass="hover-info button-hover-info"
                                                    desc={i18n.t('rapidSurvey.disabledFeatureTitle')}
                                                    linkText={i18n.t('rapidSurvey.disabledFeatureBody')}
                                                    href="mailto:support@explori.com"
                                                    dir="top"
                                                >
                                                    <Button
                                                        icon="far fa-lock-keyhole"
                                                        label={i18n.t('report_filters_add')}
                                                        cssClass="primary regular"
                                                        onClick={() => { reportStore.showFilters = true }}
                                                        style={{ justifyContent: 'center', width: '100%' }}
                                                        disabled
                                                    />
                                                </HoverInfo>
                                            ) : (
                                                <Button
                                                    cssClass="primary regular"
                                                    label={i18n.t('report_filters_add')}
                                                    icon="fa-light fa-circle-plus"
                                                    onClick={() => { reportStore.showFilters = true }}
                                                    style={{ justifyContent: 'center', width: '100%' }}
                                                />
                                            )}
                                    </div>
                                )}
                            </Accordion>
                        </Fragment>
                    )}

                    {!reportStore.showQuickFilter && (
                        <div style={{ padding: 20, position: 'relative' }}>
                            {!this.isMaxbi && (
                                survey.metadata.isRapidSurvey
                                    ? (
                                        <HoverInfo
                                            cssClass="hover-info cross-tabs-button-hover-info"
                                            desc={i18n.t('rapidSurvey.disabledFeatureTitle')}
                                            linkText={i18n.t('rapidSurvey.disabledFeatureBody')}
                                            href="mailto:support@explori.com"
                                            dir="top"
                                        >
                                            <Button
                                                icon="far fa-lock-keyhole"
                                                label={i18n.t('crossTabs')}
                                                cssClass="secondary regular"
                                                onClick={() => this.editAdvancedXTab(0)}
                                                style={{
                                                    justifyContent: 'center', width: '100%', marginBottom: '16px',
                                                }}
                                                disabled
                                            />
                                        </HoverInfo>
                                    ) : (
                                        <Button
                                            cssClass="secondary regular"
                                            label={i18n.t('crossTabs')}
                                            icon="fa-light fa-circle-plus"
                                            onClick={() => this.editAdvancedXTab(0)}
                                            style={{ justifyContent: 'center', width: '100%', marginBottom: '16px' }}
                                        />
                                    )
                            )}
                            {!this.isMaxbi && R.pathOr(0, ['userData', 'flags', 'pptLevel'], appStore) > 1 && (
                                <LinkButton
                                    href={`/survey/${survey.id}/presentation`}
                                    label={i18n.t('presentationbuilder')}
                                    target="_blank"
                                    isExternal
                                    style={{ marginBottom: '16px' }}
                                    cssClass="tertiary regular"
                                />
                            )}
                            <Button
                                cssClass="primary regular"
                                label={i18n.t('report_export_options')}
                                icon="fa-light fa-folder-arrow-down"
                                onClick={() => { appStore.downloadModalOpen = true }}
                                style={{ justifyContent: 'center', width: '100%' }}
                            />
                            {process.env.USE_NEW_EXPORT
                                ? (
                                    <Button
                                        cssClass="primary regular"
                                        label="new export modal"
                                        icon="fa-light fa-folder-arrow-down"
                                        onClick={reportStore.toggleShowExportModal}
                                        style={{ justifyContent: 'center', width: '100%', marginTop: '16px' }}
                                    />
                                )
                                : null }
                        </div>
                    )}
                </Panel>

                <Fragment>
                    {reportStore.stillLoading && (
                        <div id="overlay">
                            <div className="download">
                                <div className="downloadHeader">
                                    <span>{i18n.t('report.dataLoading')}</span>
                                    <i className="fal fa-times" onClick={reportStore.toggleStillLoading} />
                                </div>
                                <div className="downloadBody" style={{ margin: '10px' }}>
                                    {i18n.t('report.dataLoadingLongText')}
                                </div>
                            </div>
                        </div>
                    )}
                    {!reportStore.stillLoading && null}
                </Fragment>
            </Fragment>
        )
    }
}

export default LeftPanel
